import SamplePart from 'components/onboarding/sample-part'

const SampleParts = () => {
  const sampleParts = [
    {
      fileName: 'top_clamp',
      thumbnail: '/images/sample-parts/top-clamp/thumbnail.webp',
      name: 'Top Clamp',
    },
    {
      fileName: 'feature_rich_part',
      thumbnail: '/images/sample-parts/feature-rich-part/thumbnail.webp',
      name: 'Feature Rich Part',
    },
  ]

  return (
    <div className="my-2 flex w-full flex-1 flex-col items-start lg:-mt-1.5 lg:mb-0 lg:w-1/2">
      <div className="flex w-full flex-col items-start gap-1.5 lg:px-3">
        <span className="text-xl font-semibold text-gray-400">
          or Choose a Sample Part:
        </span>
        <ul className="flex w-full flex-col gap-1.5">
          {sampleParts.map((part, index) => (
            <li key={`sample-part-${index}`}>
              <SamplePart {...part} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default SampleParts
